var Search = (function() {

  function calcResultsNumber() {
    var results_num;
    var curr_viewport;
    var viewports = ["desktop", "tablet", "mobile"];

    viewports.forEach(function(elem) {
      if ($("body").hasClass(elem)) {
        curr_viewport = elem;
      }
    });

    switch (curr_viewport) {
      case "desktop":
        results_num = 10;
        break;
      case "tablet":
        results_num = 5;
        break;
      case "mobile":
        results_num = 5;
        break;
    }
    return results_num;
  }

  function getSearchTermFromUrl() {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var term = url.searchParams.get("search");
    if (term) {
      return term;
    }
  }

  function renderErrorMessage(msg, $search) {
    var aria_id = $search.find("form .searchform__input").attr("aria-describedby");
    var output = "<div id='" + aria_id + "' role='tooltip' class='error-msg'>";
    output += "<p class ='error-msg__text'>";
    output += msg;
    output += "</p>";
    output += "</div>";

    $search.find("form").after(output);
    $search.find(".error-msg").fadeTo("slow", 1);
  }

  function removeError($search) {
    $search.find(".error-msg").remove();
  }

  function validateForm(e, $search, err_msg) {
    var $searchinput = $search.find("form .searchform__input");

    var val = $searchinput.val();
    if ($.trim(val) === "") {
      e.preventDefault();
      if (!$search.find(".error-msg").length) {
        renderErrorMessage(err_msg, $search);
        $searchinput.focus();
      }
    }
  }

  return {
    calcResultsNumber: calcResultsNumber,
    getSearchTermFromUrl: getSearchTermFromUrl,
    removeError: removeError,
    validateForm: validateForm,
    renderErrorMessage: renderErrorMessage
  };

})();

export { Search };